import { createFileRoute } from '@tanstack/react-router';

import { owner, publishDate } from '@repo/privacy';
import { components } from '@repo/privacy/components/components.tsx';
import Tos from '@repo/privacy/tos.mdx';

export const Route = createFileRoute('/$pathLocale/_privacy/tos')({
  component: RouteComponent,
});

const formatter = new Intl.DateTimeFormat('it');

function RouteComponent() {
  return (
    <Tos
      owner={owner}
      formattedPublishDate={formatter.format(publishDate)}
      components={components}
    />
  );
}
